/**
 * Инициализация и уничтожение Select2 на селектах внутри модалки.
 * Использует глобальный jQuery (подключается через index.html).
 * Селекты должны иметь класс js-select2-modal и атрибут name (для синхронизации с React state).
 * onSelect2Change(name, value) — вызывается при смене значения (Select2 триггерит jQuery change, React его не видит).
 */

let select2ScrollFixInstalled = false

function prepareSelect2DropdownParent($sel) {
  if ($sel.parents('.modal:first').length) {
    return $sel.closest('.modal')
  }
  if (!$sel.parent().hasClass('sigur-select2-wrap')) {
    $sel.wrap('<div class="sigur-select2-wrap position-relative"></div>')
  }
  return $sel.parent()
}

/** Единая инициализация Select2: обёртка + dropdownParent, без выпадания в body. */
export function initSigurSelect2($sel, options = {}) {
  if (!$sel || !$sel.length || typeof window.$ === 'undefined') return
  if ($sel.data('select2')) {
    try {
      $sel.select2('destroy')
    } catch (_) {
      /* уже уничтожен */
    }
  }
  $sel.select2({
    width: '100%',
    dropdownParent: prepareSelect2DropdownParent($sel),
    ...options,
  })
}

/** Сброс ширины поля поиска при открытии — Select2 иначе раздувает страницу. */
export function installSelect2ScrollFix() {
  if (select2ScrollFixInstalled || typeof window === 'undefined' || typeof window.$ === 'undefined') {
    return
  }
  select2ScrollFixInstalled = true
  const $ = window.$
  $(document).on('select2:open', () => {
    requestAnimationFrame(() => {
      $('.select2-container--open .select2-search__field').each(function fixSearchWidth() {
        this.style.setProperty('width', '100%', 'important')
        this.style.setProperty('max-width', '100%', 'important')
        this.style.setProperty('min-width', '0', 'important')
      })
      $('body > .select2-dropdown').css('max-width', 'calc(100vw - 1rem)')
      $('.sigur-select2-wrap .select2-dropdown').css('max-width', '100%')
    })
  })
}

export function initSelect2InModal(modalElement, onSelect2Change) {
  if (!modalElement || typeof window.$ === 'undefined') return
  const $ = window.$
  const $modal = $(modalElement)
  $modal.find('select.js-select2-modal').each(function () {
    const $sel = $(this)
    if ($sel.data('select2')) return
    $sel.select2({
      dropdownParent: $sel.closest('.modal'),
      width: '100%',
    })
    if (onSelect2Change && this.getAttribute('name')) {
      $sel.on('change', function () {
        const name = this.getAttribute('name')
        const val = $(this).val()
        onSelect2Change(name, val != null ? val : '')
      })
    }
  })
}

export function destroySelect2InModal(modalElement) {
  if (!modalElement || typeof window.$ === 'undefined') return
  const $ = window.$
  $(modalElement).find('select.js-select2-modal').each(function () {
    const $sel = $(this)
    if ($sel.data('select2')) $sel.select2('destroy')
  })
}

/**
 * Уничтожить все экземпляры Select2 и убрать «залипшие» dropdown из body.
 * Нужно при уходе со страницы (например, «Назад» в админке), если destroy не вызван.
 */
export function destroyAllSelect2(root = document) {
  if (typeof window === 'undefined' || typeof window.$ === 'undefined') return
  const $ = window.$
  const $root = root === document ? $('body') : $(root)

  $root.find('select').each(function () {
    const $sel = $(this)
    if ($sel.data('select2')) {
      try {
        $sel.select2('destroy')
      } catch (_) {
        /* уже уничтожен */
      }
    }
  })

  $('body > .select2-container.select2-container--open').remove()
  $('body > .select2-dropdown').remove()
}

/**
 * Select2 в произвольном контейнере (формы админки, отчёты и т.д.).
 * Селект: class js-select2-sigur, без пустого «----» — только переданные option.
 */
export function initSelect2InContainer(
  container,
  onChange,
  selector = 'select.js-select2-sigur',
) {
  if (!container || typeof window.$ === 'undefined') return
  const $ = window.$
  $(container)
    .find(selector)
    .each(function () {
      const $sel = $(this)
      if ($sel.data('select2')) {
        $sel.off('change.sigurSelect')
      }
      initSigurSelect2($sel)
      if (onChange && this.getAttribute('name')) {
        $sel.on('change.sigurSelect', function () {
          const name = this.getAttribute('name')
          const val = $(this).val()
          onChange(name, val != null ? val : '')
        })
      }
    })
}

export function destroySelect2InContainer(container, selector = 'select.js-select2-sigur') {
  if (!container || typeof window.$ === 'undefined') return
  const $ = window.$
  $(container)
    .find(selector)
    .each(function () {
      const $sel = $(this)
      $sel.off('change.sigurSelect')
      if ($sel.data('select2')) $sel.select2('destroy')
    })
}

export function syncSelect2InContainer(container, selector = 'select.js-select2-sigur') {
  if (!container || typeof window.$ === 'undefined') return
  const $ = window.$
  $(container)
    .find(selector)
    .each(function () {
      const $sel = $(this)
      const currentVal = this.value != null ? this.value : ''
      if ($sel.data('select2')) {
        $sel.val(currentVal).trigger('change.select2')
      }
    })
}

/** Обновить отображаемое значение Select2 после смены value из React (например, после Сбросить). */
export function syncSelect2InModal(modalElement) {
  if (!modalElement || typeof window.$ === 'undefined') return
  const $ = window.$
  $(modalElement).find('select.js-select2-modal').each(function () {
    const $sel = $(this)
    const currentVal = this.value != null ? this.value : ''
    $sel.val(currentVal).trigger('change.select2')
  })
}
